var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"width":"100%","height":"1080px","src":_vm.iframeUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }